var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.list.length)?_c('div',[_c('div',{class:[_vm.$style.breadcrumbs, _vm.$style.breadcrumbs__seo]},_vm._l((_vm.items),function(item,i){return _c(_vm.setTag(item),{key:i,tag:"component",class:_vm.$style.breadcrumbs__item,attrs:{"to":item.to || null}},[_vm._v("\n      "+_vm._s(item.title)+"\n    ")])}),1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }